/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import {
  Form, Input, Row, Col, Divider, Modal, DatePicker,
} from 'antd';
import {
  DATE_FORMAT,
} from 'utils/formatters';
import Select from 'components/PaginatedSelect';
import { Button, Text } from 'components';
import propTypes from 'prop-types';
import { postDeclaracionIsanAnual, patchGenerarDeclaracion, postRechazarDeclaracion } from 'api/recaudacion';
import { SyncOutlined } from '@ant-design/icons';
import _logger from 'utils/logger';
import { toMoment } from 'utils/normalizers';
import ModalConfirm from './ModalConfirm';

const FormISANAnual = ({
  declaracionId,
  statusDeclaracion,
  padron,
  cargosGenerados,
  visible,
  setVisibleForm,
  callback,
  callbackCancel,
  isComplementaria,
}) => {
  const [formIsan] = Form.useForm();

  const [padronValues, setPadronValues] = useState([]);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [disabledActualizada, setDisabledActualizada] = useState(false);
  const [loading, setLoading] = useState(true);

  const _rules = {
    required: (message) => ({
      required: true,
      message,
    }),
    numeric: [
      {
        validator: async (_, value) => {
          const regex = /^[0-9]+([.][0-9]{1,2})?$/;
          if (!value) {
            return Promise.resolve();
          }
          if (value?.split('.')?.[1]?.length > 2) {
            return Promise.reject(new Error('Solo se permiten hasta dos decimales (0.00)'));
          }
          if (!regex.test(value)) {
            return Promise.reject(new Error('Solo se permiten números'));
          }
          return Promise.resolve();
        },
      },
    ],
    text: [
      {
        validator: async (_, value) => {
          const regex = /^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]*$/;
          if (!value) {
            return Promise.resolve();
          }
          if (!regex.test(value)) {
            return Promise.reject(new Error('Solo se permiten letras'));
          }
          return Promise.resolve();
        },
      },
    ],
    cp: [
      {
        validator: async (_, value) => {
          const regex = /^[0-9]{5}$/;
          if (value && !regex.test(value)) {
            throw new Error('Solo se permiten 5 números');
          }
        },
      },
    ],
    telefono: [
      {
        validator: async (_, value) => {
          const regex = /^[0-9]{10}$/;
          if (value && !regex.test(value)) {
            throw new Error('Solo se permiten 10 números');
          }
        },
      },
    ],
    mayorCero: [
      {
        validator: async (_, value) => {
          if (value <= 0) {
            throw new Error('El valor debe ser mayor a 0');
          } else {
            return Promise.resolve();
          }
        },
      },
    ],
    numericInt: [
      {
        validator: async (_, value) => {
          const regex = /^[0-9]+$/;
          if (!value) {
            return Promise.resolve();
          }
          if (!regex.test(value)) {
            return Promise.reject(new Error('Solo se permiten números enteros.'));
          }
          return Promise.resolve();
        },
      },
    ],
    mayorQue: (fild) => [
      {
        validator: async (_, value) => {
          const valorA = formIsan.getFieldValue(fild);

          if (parseInt(valorA, 10) > 0 && parseInt(value, 10) === 0) {
            return Promise.reject(new Error('El valor debe ser mayor a 0'));
          } if (parseInt(valorA, 10) === 0 && parseInt(value, 10) > 0) {
            formIsan.setFields([{ name: fild, errors: ['El valor debe ser mayor a 0'] }]);
          } if (parseInt(valorA, 10) === 0 && parseInt(value, 10) === 0) {
            formIsan.setFields([{ name: fild, errors: [] }]);
          }
          return Promise.resolve();
        },
      },
    ],
  };

  const handleCancel = async () => {
    setLoading(true);
    await postRechazarDeclaracion({
      declaracion: declaracionId,
      canal_de_pago: 5,
    });
    setLoading(false);
  };

  const calculaPagoEnExceso = () => {
    const valores = formIsan.getFieldsValue();
    const pago = parseInt(valores.importe_pagado_que_rectifica || 0, 10);
    const totalContribuciones = valores.total_de_contribuciones;

    if (pago > totalContribuciones) {
      formIsan.setFieldsValue({ cantidad_a_pagar: 0 });
      return Math.abs(totalContribuciones - pago);
    } if (pago === '') {
      formIsan.setFieldsValue({ importe_pagado_que_rectifica: parseInt(totalContribuciones, 10) });
    } else if (pago < totalContribuciones) {
      formIsan.setFieldsValue({ cantidad_a_pagar: parseInt(totalContribuciones - pago, 10) });
    }
    return 0;
  };

  const pagoEnExceso = () => {
    formIsan.setFieldsValue({ pago_en_exceso: calculaPagoEnExceso() });
  };

  const impuestoAcargo = () => {
    const values = formIsan.getFieldsValue();
    const impuesto = parseInt(values.isan_del_ejercicio || 0, 10) - parseInt(values.montos_de_pagos_provisionales || 0, 10);
    formIsan.setFieldsValue({ impuesto_a_cargo: parseInt(impuesto < 0 ? 0 : impuesto, 10) });

    if (impuesto <= 0) {
      setDisabledActualizada(true);
      formIsan.setFieldsValue({ parte_actualizada: 0 });
      // formIsan.validateFields(['impuesto_a_cargo']).then(() => {
      //   formIsan.setFields([{ name: 'impuesto_a_cargo', errors: ['El valor no puede ser menor o igual a 0'] }]);
      // }).catch(() => {});
    } else {
      setDisabledActualizada(false);
    }
  };

  const totalDeContribuciones = () => {
    const values = formIsan.getFieldsValue();
    const total = parseInt(values.impuesto_a_cargo || 0, 10)
    + parseInt(values.parte_actualizada || 0, 10)
    + parseInt(values.recargos || 0, 10)
    + parseFloat(values.multa_por_correccion || 0, 10);
    formIsan.setFieldsValue({ total_de_contribuciones: parseInt(total, 10) });
    pagoEnExceso();
  };

  const defaultValues = (value, _padron) => {
    if (value) {
      formIsan.setFieldsValue({
        isan_del_ejercicio: parseInt(value.importe, 10),
        parte_actualizada: 0,
        recargos: parseInt(value.recargo_total, 10),
        cantidad_a_pagar: parseInt(value.adeudo_total, 10),
        multa_por_correccion: 0,
        total_de_contribuciones: 0,
        fecha_que_rectifica: null,
        pago_en_exceso: 0,
        montos_de_pagos_provisionales: 0,
        importe_pagado_que_rectifica: 0,
        total_de_sumas_de_valor_total: 0,
        es_declaracion_en_ceros: false,
        calle: _padron.calle,
        colonia: _padron.colonia,
        codigo_postal: _padron.codigo_postal,
        municipio: _padron.municipio,
        entidad_federativa: _padron.estado,
        valor_total_enajenacion_automoviles: 0,
        valor_total_enajenacion_camiones: 0,
        valor_total_enajenacion_automoviles_exentos: 0,
        valor_total_enajenacion_vehiculos_exentos: 0,
        valor_total_enajenacion_automoviles_parcialmente_exentos: 0,
        valor_total_enajenacion_automoviles_electricos_con_motor_o_h: 0,
        valor_total_enajenacion_automoviles_con_baterias_electricas: 0,
        unidades_enajenadas_automoviles: 0,
        unidades_enajenadas_camiones: 0,
        unidades_enajenadas_automoviles_exentos: 0,
        unidades_enajenadas_vehiculos_exentos: 0,
        unidades_enajenadas_automoviles_parcialmente_exentos: 0,
        unidades_enajenadas_automoviles_electricos_con_motor_o_h: 0,
        unidades_enajenadas_automoviles_con_baterias_electricas: 0,
        unidades_enajenadas_total: 0,
        valor_enajenacion_total: 0,
        impuesto_a_cargo: 0,
      });
      totalDeContribuciones();
    }
    return '';
  };

  const sumaMontos = () => {
    const values = formIsan.getFieldsValue();
    const total = parseInt(values.valor_total_enajenacion_automoviles || 0, 10)
    + parseInt(values.valor_total_enajenacion_camiones || 0, 10)
    + parseInt(values.valor_total_enajenacion_automoviles_exentos || 0, 10)
    + parseInt(values.valor_total_enajenacion_vehiculos_exentos || 0, 10)
    + parseInt(values.valor_total_enajenacion_automoviles_parcialmente_exentos || 0, 10)
    + parseInt(values.valor_total_enajenacion_automoviles_electricos_con_motor_o_h || 0, 10)
    + parseInt(values.valor_total_enajenacion_automoviles_con_baterias_electricas || 0, 10);
    formIsan.setFieldsValue({ valor_enajenacion_total: parseInt(total, 10) });
  };

  const sumarMontosUnidades = () => {
    const values = formIsan.getFieldsValue();
    const total = parseInt(values.unidades_enajenadas_automoviles || 0, 10)
    + parseInt(values.unidades_enajenadas_camiones || 0, 10)
    + parseInt(values.unidades_enajenadas_automoviles_exentos || 0, 10)
    + parseInt(values.unidades_enajenadas_vehiculos_exentos || 0, 10)
    + parseInt(values.unidades_enajenadas_automoviles_parcialmente_exentos || 0, 10)
    + parseInt(values.unidades_enajenadas_automoviles_electricos_con_motor_o_h || 0, 10)
    + parseInt(values.unidades_enajenadas_automoviles_con_baterias_electricas || 0, 10);
    formIsan.setFieldsValue({ unidades_enajenadas_total: parseInt(total, 10) });
  };

  const patchDeclaracionStatus = async (values) => {
    try {
      let statusId = null;

      const statusObject = {
        // eslint-disable-next-line max-len
        generada: statusDeclaracion.find((status) => !status.declaracion_presentada && !status.declaracion_en_ceros)?.id,
        en_ceros: statusDeclaracion.find((status) => status.declaracion_en_ceros)?.id,
        sin_importe: statusDeclaracion.find((status) => status.descripcion === 'Declaración con Cantidades a Pagar y a Favor en Cero')?.id || 0,
        saldo_favor: statusDeclaracion.find((status) => status.descripcion === 'Declaración con Cantidad a Favor')?.id || 0,
      };

      if (parseFloat(values.pago_en_exceso) > 0) {
        statusId = statusObject.saldo_favor;
      } else if (parseFloat(values.cantidad_a_pagar) <= 0) {
        statusId = statusObject.sin_importe;
      } else {
        statusId = statusObject.generada;
      }

      const request = await patchGenerarDeclaracion({
        id: values.declaracion_empresarial,
        estatus_de_declaracion_empresarial: statusId,
        razones_para_presentar_en_ceros: values.razones_para_presentar_en_ceros,
      });

      if (!request) throw new Error('Error al actualizar la declaración.');
    } catch (error) {
      _logger(error);
    }
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      setIsVisibleModal(false);

      await formIsan.validateFields();
      const valuesForm = formIsan.getFieldsValue();

      valuesForm.valor_total_enajenacion_automoviles ?? 0;
      valuesForm.valor_total_enajenacion_camiones ?? 0;
      valuesForm.valor_total_enajenacion_automoviles_exentos ?? 0;
      valuesForm.valor_total_enajenacion_vehiculos_exentos ?? 0;
      valuesForm.valor_total_enajenacion_automoviles_parcialmente_exentos ?? 0;
      valuesForm.valor_total_enajenacion_automoviles_electricos_con_motor_o_h ?? 0;
      valuesForm.valor_total_enajenacion_automoviles_con_baterias_electricas ?? 0;
      valuesForm.unidades_enajenadas_automoviles ?? 0;
      valuesForm.unidades_enajenadas_camiones ?? 0;
      valuesForm.unidades_enajenadas_automoviles_exentos ?? 0;
      valuesForm.unidades_enajenadas_vehiculos_exentos ?? 0;
      valuesForm.unidades_enajenadas_automoviles_parcialmente_exentos ?? 0;
      valuesForm.unidades_enajenadas_automoviles_electricos_con_motor_o_h ?? 0;
      valuesForm.unidades_enajenadas_automoviles_con_baterias_electricas ?? 0;

      const _values = {
        declaracion_empresarial: declaracionId,
        entidad: 1,
        ...padronValues,
        ...valuesForm,
        cantidad_a_pagar: parseFloat(valuesForm.cantidad_a_pagar).toFixed(2),
        isan_del_ejercicio: parseFloat(valuesForm.isan_del_ejercicio).toFixed(2),
        importe_pagado_que_rectifica: parseFloat(
          valuesForm.importe_pagado_que_rectifica,
        ).toFixed(2),
        multa_por_correccion: parseFloat(valuesForm.multa_por_correccion).toFixed(2),
        parte_actualizada: parseFloat(valuesForm.parte_actualizada).toFixed(2),
        valor_total_enajenacion_automoviles: parseFloat(
          valuesForm.valor_total_enajenacion_automoviles,
        ).toFixed(2),
        valor_total_enajenacion_camiones: parseFloat(valuesForm.valor_total_enajenacion_camiones),
        pago_en_exceso: parseInt(valuesForm.pago_en_exceso, 10),
        // fecha_que_rectifica: valuesForm?.fecha_que_rectifica?.format(DATE_FORMAT) || null,
        fecha_que_rectifica: isComplementaria ? valuesForm.fecha_que_rectifica.format(DATE_FORMAT) : null,
      };

      await patchDeclaracionStatus(_values);
      await postDeclaracionIsanAnual(_values);
      callback(_values.cantidad_a_pagar <= 0);
      setIsVisibleModal(false);
      setVisibleForm(false);
      formIsan.resetFields();
      setLoading(false);
    } catch (error) {
      _logger(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const padronInfo = {
      razon_social_nombre_completo: padron?.empresa?.contribuyente?.razon_social || '',
      rfc: padron?.empresa?.contribuyente?.rfc || '',
      curp: padron?.empresa?.contribuyente?.ciudadano?.curp || '',
      nombre: padron?.empresa?.contribuyente?.ciudadano?.nombre || '',
      apellido_paterno: padron?.empresa?.contribuyente?.ciudadano?.apellido_paterno || '',
      apellido_materno: padron?.empresa?.contribuyente?.ciudadano?.apellido_materno || '',

      // EMPRESA
      estado: padron?.empresa?.direccion_de_ubicacion?.codigo_postal?.municipio?.estado?.nombre_de_AGEE || '',
      municipio: padron?.empresa?.direccion_de_ubicacion?.codigo_postal?.municipio?.nom_mun || '',
      calle: padron?.empresa?.direccion_de_ubicacion?.calle_principal || '',
      colonia: padron?.empresa?.direccion_de_ubicacion?.colonia || '',
      codigo_postal: padron?.empresa?.direccion_de_ubicacion?.codigo_postal?.d_codigo || '',
      telefono: padron?.empresa?.direccion_de_ubicacion?.telefono_fijo || padron?.empresa?.direccion_de_ubicacion?.telefono_celular || '',
    };

    defaultValues(cargosGenerados[0], padronInfo);

    setPadronValues(padronInfo);
    setLoading(false);
  }, [declaracionId, cargosGenerados]);

  const handleUnload = (event) => {
    const message = 'Se perderán los datos capturados, ¿Estás seguro de salir?';
    event.preventDefault();
    event.returnValue = message; // Esto mostrará el cuadro de confirmación
    return message;
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (visible) {
      window.addEventListener('unload', handleUnload);
      window.addEventListener('beforeunload', handleCancel);

      return () => {
        window.removeEventListener('unload', handleUnload);
        window.removeEventListener('beforeunload', handleCancel);
      };
    }
  }, [visible]);

  return (
    <>
      <Modal
        width="85vw"
        visible={visible}
        closable={false}
        title={(
          <Row justify="space-between">
            <Text $accent>
              Formato ISAN Anual
            </Text>
          </Row>
      )}
        forceRender
        centered
        footer={(
          <Row justify="end" gutter={[10, 15]}>
            <Col xs={24} sm={24} md={6}>
              <Button
                style={{ width: '100%', borderRadius: 5 }}
                onClick={() => callbackCancel()}
                loading={loading}
                $accent
              >
                Cancelar
              </Button>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Button
                type="primary"
                style={{ width: '100%' }}
                onClick={() => setIsVisibleModal(true)}
                loading={loading}
                icon={<SyncOutlined />}
                $accent
              >
                Generar
              </Button>
            </Col>
          </Row>
      )}
      >
        <Form
          form={formIsan}
          layout="vertical"
          onFinish={onFinish}
        >
          {/* <Row gutter={10}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="es_declaracion_en_ceros"
                label="¿Es Declaración en ceros?"
                required
              >
                <Select
                  placeholder="Selecciona una opción"
                  trueFalse
                  allowClear={false}
                  onChange={setIsZeroState}
                />
              </Form.Item>
            </Col>
            {
              isZeroState && (
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="razones_para_presentar_en_ceros"
                  label="Razones por las que presenta en ceros"
                  rules={[_rules.required('El campo es requerido')]}
                >
                  <Input.TextArea />
                </Form.Item>
              </Col>
              )
            }
          </Row> */}
          <Divider orientation="left">
            PRIMERA PARTE
          </Divider>
          <Row gutter={10}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="es_matriz"
                label="Matriz"
                required
              >
                <Select
                  disabled
                  placeholder="Selecciona una opción"
                  trueFalse
                  allowClear={false}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="es_sucursal"
                label="Sucursal"
                required
              >
                <Select
                  placeholder="Selecciona una opción"
                  trueFalse
                  allowClear={false}
                  onChange={(value) => {
                    formIsan.setFieldsValue({ es_matriz: !value });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="es_fabricante"
                label="Fabricante"
                key="value"
                required
              >
                <Select placeholder="Selecciona una opción" trueFalse />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="es_ensamblador"
                label="Ensambador"
                key="value"
                required
              >
                <Select placeholder="Selecciona una opción" trueFalse />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="es_distribuidor"
                label="Distribuidor"
                key="value"
                required
              >
                <Select placeholder="Selecciona una opción" trueFalse />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="es_importador"
                label="Importador"
                key="value"
                required
              >
                <Select placeholder="Selecciona una opción" trueFalse />
              </Form.Item>
            </Col>
          </Row>
          <Divider orientation="left">
            SEGUNDA PARTE
          </Divider>
          <Row gutter={10}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="isan_del_ejercicio"
                label="(A) ISAN DEL EJERCICIO"
                hasFeedback
                rules={[
                  // _rules.required('El campo es requerido'),
                  // ..._rules.mayorCero,
                  ..._rules.numericInt,
                ]}
              >
                <Input onChange={() => {
                  impuestoAcargo();
                  totalDeContribuciones();
                }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="montos_de_pagos_provisionales"
                label="(B) MONTO DE LOS PAGOS PROVISIONALES"
                hasFeedback
                rules={[
                  // _rules.required('El campo es requerido'),
                  // ..._rules.mayorCero,
                  ..._rules.numericInt,
                ]}
              >
                <Input onChange={() => {
                  impuestoAcargo();
                  totalDeContribuciones();
                }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="impuesto_a_cargo"
                label="(C) IMPUESTO A CARGO (A - B)"
                hasFeedback
                rules={[
                  // _rules.required('El campo es requerido'),
                  // ..._rules.mayorCero,
                ]}
              >
                <Input onChange={() => totalDeContribuciones()} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="parte_actualizada"
                label="(D) Parte actualizada"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                  ..._rules.numericInt,
                ]}
              >
                <Input
                  disabled={disabledActualizada}
                  onChange={() => totalDeContribuciones()}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="recargos"
                label="(E) Recargos"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                  ..._rules.numericInt,
                ]}
              >
                <Input onChange={() => totalDeContribuciones()} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="multa_por_correccion"
                label="(F) Multa por corrección"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                  ..._rules.numericInt,
                ]}
              >
                <Input onChange={() => totalDeContribuciones()} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="total_de_contribuciones"
                label="(G) Total de contribuciones (C + D + E + F)"
                hasFeedback
              >
                <Input
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="importe_pagado_que_rectifica"
                label="(H) Importe pagado que rectifica"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                  ..._rules.numericInt,
                ]}
              >
                <Input onChange={() => pagoEnExceso()} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              {
                isComplementaria && (
                <Form.Item
                  name="fecha_que_rectifica"
                  label="Fecha que rectifica"
                  hasFeedback
                  rules={[
                    _rules.required('El campo es requerido'),
                  ]}
                >
                  <DatePicker
                    format={DATE_FORMAT}
                    disabledDate={(d) => d.isAfter(toMoment(new Date()))}
                  />
                </Form.Item>
                )
              }
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="pago_en_exceso"
                label="(G) Pago en exceso (en su caso G - H)"
                hasFeedback
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="cantidad_a_pagar"
                label="(H) Cantidad a pagar (G - H)"
                hasFeedback
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <Divider orientation="left">TERCERA PARTE</Divider>
          <Col xs={24} sm={24} md={24}>
            <Row gutter={10}>
              <table>
                <thead>
                  <tr>
                    <th>Concepto</th>
                    <th>Unidades enanjenadas</th>
                    <th>Valor total de la enajenación</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ marginBottom: '50px' }}>
                    <td>
                      <span>
                        I. Automóviles enajenados en el mercado nacional
                        (Artículo 3 fracción I de la Ley Federal del ISAN).
                      </span>
                    </td>
                    <td>
                      <Form.Item
                        name="unidades_enajenadas_automoviles"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                          ..._rules.numericInt,
                          ..._rules.mayorQue('valor_total_enajenacion_automoviles'),
                        ]}
                      >
                        <Input onChange={() => {
                          sumarMontosUnidades();
                        }}
                        />
                      </Form.Item>
                    </td>
                    <td>
                      <Form.Item
                        name="valor_total_enajenacion_automoviles"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                          ..._rules.numericInt,
                          ..._rules.mayorQue('unidades_enajenadas_automoviles'),
                        ]}
                      >
                        <Input onChange={() => { sumaMontos(); }} />
                      </Form.Item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>
                        J. Camiones enajenados en el mercado nacional
                        (Artículo 8 fracción I de la Ley Federal del ISAN).
                      </span>
                    </td>
                    <td>
                      <Form.Item
                        name="unidades_enajenadas_camiones"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                          ..._rules.numericInt,
                          ..._rules.mayorQue('valor_total_enajenacion_camiones'),
                        ]}
                      >
                        <Input onChange={() => sumarMontosUnidades()} />
                      </Form.Item>
                    </td>
                    <td>
                      <Form.Item
                        name="valor_total_enajenacion_camiones"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                          ..._rules.numericInt,
                          ..._rules.mayorQue('unidades_enajenadas_camiones'),
                        ]}
                      >
                        <Input onChange={() => sumaMontos()} />
                      </Form.Item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>
                        K. Automóviles exentos en el mercado nacional
                        (Artículo 8 fracción I de la Ley Federal del ISAN).
                      </span>
                    </td>
                    <td>
                      <Form.Item
                        name="unidades_enajenadas_automoviles_exentos"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                          ..._rules.numericInt,
                          ..._rules.mayorQue('valor_total_enajenacion_automoviles_exentos'),
                        ]}
                      >
                        <Input onChange={() => sumarMontosUnidades()} />
                      </Form.Item>
                    </td>
                    <td>
                      <Form.Item
                        name="valor_total_enajenacion_automoviles_exentos"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                          ..._rules.numericInt,
                          ..._rules.mayorQue('unidades_enajenadas_automoviles_exentos'),
                        ]}
                      >
                        <Input onChange={() => sumaMontos()} />
                      </Form.Item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>
                        K1. Automóviles enanjenados parcialmente exentos
                        en el mercado nacional
                        <br />
                        (Artículo 8 fracción II, segundo párrafo de la Ley Federal del ISAN)
                      </span>
                    </td>
                    <td>
                      <Form.Item
                        name="unidades_enajenadas_automoviles_parcialmente_exentos"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                          ..._rules.numericInt,
                          ..._rules.mayorQue('valor_total_enajenacion_automoviles_parcialmente_exentos'),
                        ]}
                      >
                        <Input onChange={() => sumarMontosUnidades()} />
                      </Form.Item>
                    </td>
                    <td>
                      <Form.Item
                        name="valor_total_enajenacion_automoviles_parcialmente_exentos"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                          ..._rules.numericInt,
                          ..._rules.mayorQue('unidades_enajenadas_automoviles_parcialmente_exentos'),
                        ]}
                      >
                        <Input onChange={() => sumaMontos()} />
                      </Form.Item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>
                        L. Vehiculos exentos en el mercado nacional
                        (Artículo 8 fracción III de la Ley)
                      </span>
                    </td>
                    <td>
                      <Form.Item
                        name="unidades_enajenadas_vehiculos_exentos"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                          ..._rules.numericInt,
                          ..._rules.mayorQue('valor_total_enajenacion_vehiculos_exentos'),
                        ]}
                      >
                        <Input onChange={() => sumarMontosUnidades()} />
                      </Form.Item>
                    </td>
                    <td>
                      <Form.Item
                        name="valor_total_enajenacion_vehiculos_exentos"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                          ..._rules.numericInt,
                          ..._rules.mayorQue('unidades_enajenadas_vehiculos_exentos'),
                        ]}
                      >
                        <Input onChange={() => sumaMontos()} />
                      </Form.Item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>
                        M1. Automóviles enanjenados o importados definitivamente,
                        excentos en el mercado nacional
                      </span>
                    </td>
                    <td>
                      <Form.Item
                        name="unidades_enajenadas_automoviles_con_baterias_electricas"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                          ..._rules.numericInt,
                          ..._rules.mayorQue('valor_total_enajenacion_automoviles_con_baterias_electricas'),
                        ]}
                      >
                        <Input onChange={() => sumarMontosUnidades()} />
                      </Form.Item>
                    </td>
                    <td>
                      <Form.Item
                        name="valor_total_enajenacion_automoviles_con_baterias_electricas"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                          ..._rules.numericInt,
                          ..._rules.mayorQue('unidades_enajenadas_automoviles_con_baterias_electricas'),
                        ]}
                      >
                        <Input onChange={() => sumaMontos()} />
                      </Form.Item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>
                        M2. Automóviles elécticos que
                        además cuentan con motor de combustión interna o
                        <br />
                        con motor accionado por
                        hidrógeno enanjenados o importados definitivamente,
                        <br />
                        exentos en el mercado
                        nacional
                      </span>
                    </td>
                    <td>
                      <Form.Item
                        name="unidades_enajenadas_automoviles_electricos_con_motor_o_h"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                          ..._rules.numericInt,
                          ..._rules.mayorQue('valor_total_enajenacion_automoviles_electricos_con_motor_o_h'),
                        ]}
                      >
                        <Input onChange={() => sumarMontosUnidades()} />
                      </Form.Item>
                    </td>
                    <td>
                      <Form.Item
                        name="valor_total_enajenacion_automoviles_electricos_con_motor_o_h"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                          ..._rules.numericInt,
                          ..._rules.mayorQue('unidades_enajenadas_automoviles_electricos_con_motor_o_h'),
                        ]}
                      >
                        <Input onChange={() => sumaMontos()} />
                      </Form.Item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      P.TOTAL
                    </td>
                    <td>
                      <Form.Item name="unidades_enajenadas_total" hasFeedback>
                        <Input disabled />
                      </Form.Item>
                    </td>
                    <td>
                      <Form.Item
                        name="valor_enajenacion_total"
                        hasFeedback
                        rules={[
                          _rules.required('El campo es requerido'),
                        ]}
                      >
                        <Input disabled />
                      </Form.Item>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Row>
          </Col>
          <Divider orientation="left">DATOS DEL REPRESENTANTE LEGAL</Divider>
          <Row gutter={10}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="representante_legal_rfc"
                label="Registro Federal de Contribuyentes"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="representante_legal_curp"
                label="Clave única de registro de población"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="representante_legal_apellido_paterno"
                label="Apellido paterno"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="representante_legal_apellido_materno"
                label="Apellido materno"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="representante_legal_nombre"
                label="Nombre(s)"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Divider orientation="left">DATOS INFORMATIVOS</Divider>
          <Row gutter={10}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="numero_vehiculos_incorp_activo_fijo"
                label="Número de vehículos incorporados al activo fijo"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                  ..._rules.numeric,
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="factura_inicial_del_periodo"
                label="Facturas expedidas en el periodo que se declara"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="factura_final_del_periodo"
                label="Factura final del periodo"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Divider orientation="left">
            DOMICILIO DEL ESTABLECIMIENTO
          </Divider>
          <Row gutter={10}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="calle"
                label="Calle"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="nro_letra_exterior"
                label="Número/letra exterior"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="nro_letra_interior"
                label="Número/letra interior"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="colonia"
                label="Colonia"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="municipio"
                label="Municipio"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="codigo_postal"
                label="Código postal"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                ]}
              >
                <Input maxLength={5} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="localidad"
                label="Localidad"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="entidad_federativa"
                label="Entidad federativa"
                hasFeedback
                rules={[
                  _rules.required('El campo es requerido'),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item
                name="telefono"
                label="Teléfono"
                hasFeedback
                rules={_rules.telefono}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <ModalConfirm
        visible={isVisibleModal}
        setVisible={setIsVisibleModal}
        onFinish={() => onFinish()}
        body="Al generar la declaración no podrá ser modificada. ¿Desea continuar?"
        loading={loading}
      />
    </>
  );
};

FormISANAnual.propTypes = {
  declaracionId: propTypes.number.isRequired,
  padron: propTypes.shape({
    empresa: propTypes.shape({
      contribuyente: propTypes.shape({
        razon_social: propTypes.string,
        rfc: propTypes.string,
        ciudadano: propTypes.shape({
          curp: propTypes.string,
          nombre: propTypes.string,
          apellido_paterno: propTypes.string,
          apellido_materno: propTypes.string,
        }),
      }),
      direccion_de_ubicacion: propTypes.shape({
        colonia: propTypes.string,
        telefono_celular: propTypes.string,
        telefono_fijo: propTypes.string,
        calle_principal: propTypes.string,
        codigo_postal: propTypes.shape({
          d_codigo: propTypes.string,
          municipio: propTypes.shape({
            nom_mun: propTypes.string,
            estado: propTypes.shape({
              nombre_de_AGEE: propTypes.string,
            }),
          }),
        }),
      }),
    }),
  }).isRequired,
  statusDeclaracion: propTypes.number.isRequired,
  callbackCancel: propTypes.func.isRequired,
  visible: propTypes.bool,
  setVisibleForm: propTypes.func.isRequired,
  callback: propTypes.func.isRequired,
  cargosGenerados: propTypes.arrayOf(propTypes.shape({
    adeudo_total: propTypes.number,
  })),
  isComplementaria: propTypes.bool,
};

FormISANAnual.defaultProps = {
  cargosGenerados: [],
  visible: false,
  isComplementaria: false,
};

export default FormISANAnual;
